import script from "./ClassroomsList.vue?vue&type=script&setup=true&lang=js"
export * from "./ClassroomsList.vue?vue&type=script&setup=true&lang=js"

import "./ClassroomsList.vue?vue&type=style&index=0&id=3562f15a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3562f15a"]])

export default __exports__